<template>
    <div>
        <div v-if="!editMode" class="form-inline"><span>{{currentTypeLabel}}</span>  <i class="far fa-edit ml-2" v-on:click="editClick"></i></div>
        <div v-else class="form-inline">
            <div v-if="isWorking">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div v-else>
                <select v-model="selected" class="form-control form-control-sm mr-2">
                    <option disabled :value="null">Please select one</option>
                    <option v-for="(t, i) in intDocTypes" :key="i" :value="t">{{t.label}}</option>
                </select>
                <span>
                    <i class="far fa-save mr-2" v-on:click="saveClick"></i>
                    <i class="far fa-window-close" v-on:click="cancelClick"></i>
                </span>
            </div>
        </div>
    </div>
</template>

<script>   

    export default {
        name: "attachment-document-type",
        props: {
            documentId: {
                type: Number,
                required: true
            },
            currentType: {
                required: false,
                validator: function (obj) {
                    return (obj.id && Number.isInteger(obj.id) && obj.label && obj.label.length);
                }
            },
            documentTypes: {
                type: Array,
                required: false,
                default: () => []
            }
        },
        data: () => {
            return {
                editMode: false,
                selected: null,
                isWorking: false
            };
        },
        watch: {
        },
        computed: {
            currentTypeLabel() {
                if (this.currentType && this.currentType.label && this.currentType.label.length) {
                    return this.currentType.label
                } else {
                    return 'NOT_SELECTED'
                }
            },
            intDocTypes() {
                return this.documentTypes.map(t => ({ id: t.id, label: t.label }))
            }
        },
        methods: {
            editClick() {
                this.editMode = true
            },
            cancelClick() {
                this.editMode = false
                this.selected = null
            },
            saveClick() {
                if (this.selected != null) {
                    let { documentId, selected } = this
                    this.$emit('save-click', { documentId, selected })
                    //this.isWorking = true
                    this.selected = null
                }
            }
        },
        beforeMount() {
            
        },
        mounted() {
            
        }
    };
</script>

